export const labels = {
	replace: {
		label: "Label.MobileCreator.BottomMenu.Photo.Replace",
		default: "Replace",
	},
	delete: {
		label: "Label.MobileCreator.BottomMenu.Photo.Delete",
		default: "Delete",
	},
	clear: {
		label: "Label.MobileCreator.BottomMenu.Photo.Clear",
		default: "Clear",
		// description: "The clears the content of the photo zone. It does NOT delete the photo zone"
	},
	rotate: {
		label: "Label.MobileCreator.BottomMenu.Photo.Rotate",
		default: "Rotate",
	},
	photoEdit: {
		label: "Label.MobileCreator.BottomMenu.Photo.Edit",
		default: "Photo Edit",
	},
	filters: {
		label: "Label.MobileCreator.BottomMenu.Filters",
		default: "Filters",
	},
	addPhotoZone: {
		label: "Label.MobileCreator.BottomMenu.Photo.AddPhotoZone",
		default: "Add photo zone",
	},
	transform: {
		label: "Label.MobileCreator.BottomMenu.Photo.Transform",
		default: "Transform",
	},
	photoPosition: {
		label: "Label.MobileCreator.BottomMenu.Zone.Position",
		default: "Position",
	},
};
